import {useState, useEffect} from "react"
import Layout from "../../layouts/default";
import { useSelector, useDispatch } from "react-redux";
import { getBlockContacts } from "../../store/slices/blockContacts/blockRecipients";
import ModalDialog from "../../components/UI/ModalDialog";
import BlockContactAddNew from "../../components/BlockContact/AddNew"
import BlockContactListItems from "../../components/BlockContact/ListItems";

const BlockContactsByTags = () =>{
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [filterData, setFilterData] = useState({scopeType:'Tags'});
  const { blockContacts } = useSelector((state) => state.blockContactsSlice);
  const { refreshBlockContact } = useSelector((state) => state.blockContactCreatetSlice);
  const { refreshBlockContactDel } = useSelector((state) => state.blockContactDeleteSlice);
  const [isShow, setIsShow] = useState(false)
  const [selectedContact, setSelectedContact] = useState(false)
  const dispatch = useDispatch()

  useEffect(()=>{
    console.log('getBlockContacts loading.....refreshBlockContact')
    dispatch(getBlockContacts({ page, filterData }));
  },[dispatch, loading, page, filterData,refreshBlockContact, refreshBlockContactDel])

  const modalCloseHandler = () =>{
    setIsShow(false)
  }
  
    return (
        <Layout>
         <BlockContactListItems 
         blockContacts={blockContacts} 
         setFilterData={setFilterData} 
         setIsShow={setIsShow} 
         setSelectedContact={setSelectedContact} 
         setPage={setPage} 
         page={page} 
         setLoading={setLoading} 
         scopeType="Tags"
         />   
      {isShow && <ModalDialog title="Global - Add Contact to Block" isShow={isShow}
      onClose={modalCloseHandler}>
        <BlockContactAddNew 
          scopeType="Tags" 
          contact={selectedContact} 
          onAddUpdate={modalCloseHandler}
          />
      </ModalDialog>}
        </Layout>
    )
}

export default BlockContactsByTags